import styles from './style.postcss';

import React from 'react';
import classnames from 'classnames';
import NormalTd from '../NormalTd';
import PropTypes from 'prop-types';

const StatusTd = (props) => {
  let className;
  switch (props.text) {
    case 'ACTIVE':
      className = styles.__green;
      break;
    case 'MAINTENANCE':
    case 'PENDING':
      className = styles.__orange;
      break;
    case 'DEACTIVATED':
    case 'OVERDUE':
      className = styles.__red;
      break;
    default:
      className = '';
  }
  return <NormalTd>
    <span className={classnames(styles.StatusField_status, className)}>
      {props.text}
    </span>
  </NormalTd>;
};

StatusTd.propTypes = {
  text: PropTypes.string,
};

export default StatusTd;



// WEBPACK FOOTER //
// ./components/TableView/Tds/StatusTd/index.jsx